import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=7fb478d0&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=7fb478d0&prod&scoped=true&lang=css&external"
import style1 from "./feedback.vue?vue&type=style&index=1&id=7fb478d0&prod&scoped=true&lang=css"
import style2 from "./feedback.vue?vue&type=style&index=2&id=7fb478d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb478d0",
  null
  
)

export default component.exports